import { render } from "./AwardStock.vue?vue&type=template&id=df8d6a00"
import script from "./AwardStock.vue?vue&type=script&lang=js"
export * from "./AwardStock.vue?vue&type=script&lang=js"

import "./AwardStock.vue?vue&type=style&index=0&id=df8d6a00&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__